'use client'

import { useSession } from 'next-auth/react'
import { useRouter, usePathname } from 'next/navigation'
import { SessionProvider } from 'next-auth/react'
import { useEffect } from 'react'

const AuthCheck = ({ children }: { children: React.ReactNode }) => {
  const { data: session, status } = useSession()
  const router = useRouter()
  const pathname = usePathname()

  const publicPaths = ['/', '/login', '/register', '/about', '/news', '/column', '/search']

  useEffect(() => {
    if (status === 'loading') return

    // if (!session && !publicPaths.includes(pathname)) {
    //   router.push('/login')
    // }
  }, [session, status, router, pathname])

  if (status === 'loading') {
    return <div className="absolute top-0 left-0 w-full h-screen bg-white bg-opacity-50 flex justify-center items-center z-[1050]">
      <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  }

  return <>{children}</>
}

export default function ClientProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <SessionProvider>
      <AuthCheck>{children}</AuthCheck>
    </SessionProvider>
  )
}
